export default "__VITE_ASSET__OpsJI5uw__"